import {
  Box,
  Flex,
  // Heading,
  HStack,
  Image,
  Link,
  Icon,
  Spacer,
  VStack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { MdMenu } from "react-icons/md";
import { CloseIcon } from "@chakra-ui/icons";
import React, { useState, useEffect, useRef } from "react";
import Enso from "../../../assets/images/Enso_Logo_080.png";
// import glass1 from "../../../assets/images/glass1.jpg";
// import glass2 from "../../../assets/images/glass2.jpg";
// import glass3 from "../../../assets/images/glass3.jpg";
// import glass4 from "../../../assets/images/glass4.jpg";
// import glass5 from "../../../assets/images/glass5.jpg";
// import glass6 from "../../../assets/images/glass6.jpg";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import * as Constants from "../../../constants/Constants";

const Header = (props) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [images, setImages] = useState([]);
  const [productsMenuVisible, setProductsMenuVisible] = useState(false);
  const scrolledRef = useRef(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const location = useLocation();
  const isActiveRoute = (path, isDropdown = false) => {
    if (path === "/project") {
      return (
        location.pathname === "/project" ||
        location.pathname.startsWith("/ProjectDetails/")
      );
    }
    if (isDropdown) {
      return location.pathname.startsWith("/product/");
    }
    return location.pathname === path;
  };
 useEffect(() => {
        axios
          .get(Constants.REACT_APP_API_URL + "api/upload/about")
          .then((res) => {
            if (res.data.success) {
              setImages(res.data.data);
            }
          })
          .catch((err) => console.log(err));
      }, []);
  // header background
  const bg =
    location.pathname === "/contact"
      ? scrolledRef.current
      ? "#000000"   // 👈 contact page after scroll
      : "#ffffff"
      : scrolledRef.current
      ? "rgba(0,0,0,0.7)"
      : "black"
  useEffect(() => {
    if (hoveredItem) {
      console.log(`Hovered over: ${hoveredItem}`);
    }
  }, [hoveredItem]);

  const handleMenuLeave = (e) => {
    const relatedTarget = e.relatedTarget;
    const productList = document.getElementById("productList");
    if (
      relatedTarget instanceof Node &&  
      e.currentTarget &&
      productList &&
      !e.currentTarget.contains(relatedTarget) &&
      !productList.contains(relatedTarget)
      // document.getElementById("productList")
    ) {
      // const productList = document.getElementById("productList");
      // if (
      //   !e.currentTarget.contains(relatedTarget) &&
      //   productList &&
      //   !productList.contains(relatedTarget)
      // ) {
        setMenuVisible(false);
        setHoveredItem(null);
      // }
    }
  };

  const handleMenuEnter = () => {
    setMenuVisible(true);
  };

  const handleClick = (event, type) => {
    if (type === "menu") {
      setMenuVisible((prev) => !prev);
    }
  };

  const productImages = {
    "Sliding Partitions": images[1]?.image_url,
    "Swing Partitions": images[2]?.image_url,
    // "Flush Doors": glass3,
    "Bathroom & Wardrobes": images[3]?.image_url,
    "Shower Enclosures": images[4]?.image_url,
    "Led Mirrors": images[5]?.image_url,
  };

  // Add these animation variants at the top of your component
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1, // Delay between each child animation
      },
    },
  };

  const itemVariants = {
    hidden: { y: -20, opacity: 0 },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        scrolledRef.current = true; 
      } else {
        scrolledRef.current = false; 
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
      <Flex
        as="header"
         bg={scrolledRef.current ? "#ffffff" : "transparent"}
        pl={{base:4,md:16}}
        pr={{base:4,md:14}}
        pt={2}
        pb={4}
        color="black"
        align="end"
        position="fixed"
        top="0"
        width="100%"
        zIndex="5000"
        transition="all 0.3s ease"
      >
    {/* <VStack spacing={1} align="center"> */}
        <Flex
          justify="start"
          align="start"
          width="70px"
          overflow="hidden"
        >
          <Image
            mt="0.8rem"
            src={Enso}
            alt="Enso"
            objectFit="cover"
            width="100%"
            transition="transform 0.3s ease"
          />
        </Flex>
        {/* <Heading
          size="md"
          color="gold.500"
          fontWeight="bold"
          letterSpacing="wider"
          textShadow="1px 1px 2px rgba(0, 0, 0, 0.2)"
          transition="color 0.3s ease"
          _hover={{ color: "gold.400" }}
        >
          Luxury Living
        </Heading>
        </VStack> */}
        <Spacer />
        {isMobile && (
          <>
            <Icon
              as={MdMenu}
              boxSize="2rem"
              mr={4}
              onClick={(event) => handleClick(event, "menu")}
              display={{ base: "block", md: "none" }}
              _hover={{ cursor: "pointer", color: "rgba(0,0,0,0.7)" }}
            />
            {menuVisible && !productsMenuVisible && (
              <motion.div
                // initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <Box
                  position="absolute"
                  top="60px"
                  left="0"
                  bg="rgba(0, 0, 0, 0.9)"
                  color="white"
                  boxShadow="lg"
                  zIndex="1000"
                  p={4}
                  width="100%"
                >
                  <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="show"
                  >
                    <VStack
                      spacing={8}
                      align="center"
                      gap={"5rem"}
                      mb={"16rem"}
                      mt={"4rem"}
                    >
                      {[
                        { text: "Home", path: "/" },
                        { text: "About Us", path: "/about" },
                        { text: "Products", path: "#", isDropdown: true }, // Products entry with dropdown
                        { text: "Projects", path: "/project" },
                        { text: "Downloads", path: "/download" },
                        { text: "Contact Us", path: "/contact" },
                      ].map((item) => (
                        <motion.div key={item.text} variants={itemVariants}>
                          <Box position="relative">
                            <Link
                              key={item.text}
                              href={item.path}
                              color={
                                isActiveRoute(item.path, item.isDropdown)
                                  ? "white"
                                  : "white"
                              }
                              opacity={isActiveRoute(item.path, item.isDropdown) ? 1 : 0.5}
                              _hover={{ bg: "#000000" }}
                              onClick={(e) => {
                                e.preventDefault(); // Prevent default link behavior
                                if (item.text === "Products") {
                                  setProductsMenuVisible(true); // Show products submenu
                                } else {
                                  window.location.href = item.path; // Navigate to the path
                                }
                              }}
                            >
                              {item.text}
                            </Link>
                          </Box>
                        </motion.div>
                      ))}
                    </VStack>
                  </motion.div>
                </Box>
              </motion.div>
            )}
            {productsMenuVisible && (
              <motion.div
                // initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Box
                  position="absolute"
                  top="60px" // Adjust based on your layout
                  left="0"
                  bg="rgba(0, 0, 0, 0.95)"
                  color="#000000"
                  p={4}
                  boxShadow="md"
                  zIndex="1000"
                  width="100%" // Full width for mobile
                >
                  <Box
                    align="end"
                    onClick={() => {
                      setProductsMenuVisible(false); // Close submenu
                    }}
                  >
                    <CloseIcon marginRight={2} color="white" />
                  </Box>
                  <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="show"
                  >
                    <VStack spacing={4} align="center">
                      <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="show"
                  >
                      <Text
                        fontWeight="bold"
                        mt={4}
                        mb={4}
                        color="#000000"
                      ></Text>
                      <VStack
                        align="center"
                        gap={"5rem"}
                        mb={"18rem"}
                        mt={"8rem"}
                      >
                        {[
                          { name: "Sliding Partitions", path: "/product/1" },
                          { name: "Swing Partitions", path: "/product/2" },
                          // { name: "Flush Doors", path: "/product/3" },
                          { name: "Bathroom & Wardrobes", path: "/product/4" },
                          { name: "Shower Enclosures", path: "/product/5" },
                          { name: "Led Mirrors", path: "/product/6" },
                        ].map((subItem) => (
                          <motion.div key={subItem.text} variants={itemVariants}>
                          <Link
                            key={subItem.name}
                            href={subItem.path}
                            color={
                              location.pathname === subItem.path
                                ? "rgba(0,0,0,0.7)"
                                : "white"
                            }
                            _hover={{ bg: "#3ABFF8" }}
                          >
                            {subItem.name}
                          </Link>
                          </motion.div>
                        ))}
                      </VStack>
                      </motion.div>
                    </VStack>
                  </motion.div>
                </Box>
              </motion.div>
            )}
          </>
        )}
        <HStack spacing={8} display={{ base: "none", md: "flex" }} mb="0.3rem">
          {[
            { text: "Home", path: "/" },
            { text: "About Us", path: "/about" },
            { text: "Products", path: "#", isDropdown: true },
            // { text: "Channel Partners", path: "/channelPartners" },
            { text: "Projects", path: "/project" },
            { text: "Downloads", path: "/download" },
            { text: "Contact Us", path: "/contact" },
          ].map((item) => {
            // 🟣 Determine active state
            // const isActive = item.isDropdown
            //   ? location.pathname.startsWith("/product/") ||
            //     location.pathname.startsWith("/ProjectDetails/")
            //   : location.pathname === item.path;
            // const isActive = isActiveRoute(item.path, item.isDropdown);
            if (item.isDropdown) {
              return (
                <Box
                  key={item.text}
                  position="relative"
                  onMouseEnter={handleMenuEnter}
                  onMouseLeave={handleMenuLeave}
                >
                  <Link
                    key={item.text}
                    href={item.path}
                    className="link-hover"
                    color={bg}
                    _hover={{
                      color: "rgba(0,0,0,0.7)",
                      transform: "translateY(-2px)",
                    }}
                    transition="all 0.2s ease"
                  >
                    {item.text}
                  </Link>
                  {menuVisible && (
                    <Flex
                      position="absolute"
                      top="100%"
                      left="-100%"
                      bg="rgba(255, 255, 255, 0.95)"
                      color="#000000"
                      borderRadius="md"
                      boxShadow="xl"
                      zIndex="1000"
                      p={6}
                      minWidth="458px"
                      backdropFilter="blur(8px)"
                      animation="fadeIn 0.3s ease-in-out"
                    >
                      <VStack id="productList" align="start" spacing={4}>
                        {[
                          { name: "Sliding Partitions", path: "/product/1" },
                          { name: "Swing Partitions", path: "/product/2" },
                          // { name: "Flush Doors", path: "/product/3" },
                          { name: "Bathroom & Wardrobes", path: "/product/4" },
                          { name: "Shower Enclosures", path: "/product/5" },
                          { name: "Led Mirrors", path: "/product/6" },
                        ].map((subItem) => (
                          <Link
                            key={subItem.name}
                            href={subItem.path}
                            color={
                              location.pathname === subItem.path
                                ? "black"
                                : "black"
                            }
                            onMouseEnter={() => setHoveredItem(subItem.name)}
                            _hover={{
                              color: "#000000",
                              transform: "translateX(10px)",
                            }}
                            transition="all 0.2s ease"
                            fontSize="md"
                            fontWeight="medium"
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </VStack>
                      <Box width="100%" pl={2} transition="all 0.3s ease">
                        <Image
                          src={
                            hoveredItem ? productImages[hoveredItem] : images[1]?.image_url
                          }
                          alt={hoveredItem || "Product Image"}
                          borderRadius="md"
                          boxSize="300px"
                          objectFit="fill"
                          transition="all 0.3s ease"
                          _hover={{ transform: "scale(1.05)" }}
                          style={{
                            opacity: hoveredItem ? 1 : 0.8,
                            transform: hoveredItem ? "scale(1)" : "scale(0.95)",
                          }}
                        />
                      </Box>
                    </Flex>
                  )}
                </Box>
              );
            } else {
              return (
                <Link
                  key={item.text}
                  href={item.path}
                  className="link-hover"
                  color={bg}
                  _hover={{
                    color: "rgba(0,0,0,0.7)",
                    transform: "translateY(-2px)",
                  }}
                  transition="all 0.2s ease"
                >
                  {item.text}
                </Link>
              );
            }
          })}
        </HStack>
      </Flex>
  );
};

export default Header;
